import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_project_amenity = async (amenity) => {
  try {
    let data = new FormData();
    data.append("image", amenity?.image[0]);
    data.append("name", amenity?.name);
    data.append("title", amenity?.title);
    data.append("description", amenity?.description);
    data.append("status", amenity?.status);

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/create-project-amenity`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const update_project_amenity = async (amenity) => {
  try {
    let data = new FormData();
    data.append("id", amenity?.id);
    data.append("image", amenity?.image[0]);
    data.append("name", amenity?.name);
    data.append("title", amenity?.title);
    data.append("description", amenity?.description);
    data.append("status", amenity?.status);

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/update-project-amenity`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const get_project_amenity = async (amenity) => {
  try {
    const data = {
      id: amenity?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-project-amenity`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const get_all_project_amenities = async (amenity) => {
  try {
    const data = {
      search: amenity?.search,
      sort: amenity?.sort,
      status: amenity?.status,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-project-amenities`,
      data,
      config
    );

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

export {
  create_project_amenity,
  update_project_amenity,
  get_project_amenity,
  get_all_project_amenities,
};
